const merge = require('deepmerge')

const defaults = {
  staticExceptions: ['/static', '/_next'],
  apiRoot: '',
  apiBase: '/api/v1',
  analyticsUrl: '',
  analyticsDefaults: {
    project_name: 'discountfares',
    class: 'economy',
    request_type: 'form',
    prefered_contact: 'any',
    from_dev: 1,
  },
}

// config overrides

const ENVIRONMENTS = {
  DEV: {
    apiRoot: `https://admin.discount-fares.com`,
    analyticsUrl: `https://rcsr.stage-travel.com/interface/pixel/core/`,
    analyticsDefaults: { from_dev: 1 },
  },

  PROD: {
    apiRoot: 'https://admin.discount-fares.com',
    analyticsUrl: 'https://discount-fares.com/tracker/interface/pixel/core/',
    analyticsDefaults: { from_dev: 0 },
  },
}

// eslint-disable-next-line no-console
// console.log(process.env.ENVIRONMENT)

const ENV = process.env.NODE_ENV !== 'production' ? 'DEV' : 'PROD'
module.exports = merge(defaults, ENVIRONMENTS[ENV])
